import { Button, Input, Rate, Table } from "antd";
import { getColumns } from "./modules/getColumns";
import { useReviewManagement } from "./modules/useReviewManagement";

const { Search } = Input;

function ReviewManagementTemplate() {
  const {
    filteredReviews,
    loading,
    searchKeyword,
    filterRating,
    handleFilterByRating,
    handleSearch,
    resetFilters,
    handleDeleteReview,
    setSearchKeyword,
  } = useReviewManagement();
  // Table columns
  const columns = getColumns({ handleDeleteReview });

  return (
    <div className="container">
      <h1>Review Management</h1>
      <div className="filter-section" style={{ marginBottom: "16px" }}>
        <Search
          placeholder="Search by comment or booking ID"
          enterButton
          onSearch={handleSearch}
          value={searchKeyword}
          onChange={(e) => setSearchKeyword(e.target.value)}
          style={{ width: 300, marginRight: "16px" }}
        />
        <span style={{ marginRight: "8px" }}>Filter By Rating:</span>
        <Rate
          allowClear
          value={filterRating}
          onChange={handleFilterByRating}
          style={{ marginRight: "16px" }}
        />
        <Button onClick={resetFilters}>Reset Filters</Button>
      </div>
      <Table
        dataSource={filteredReviews}
        columns={columns}
        rowKey={(record) => record._id}
        loading={loading}
        pagination={{ pageSize: 10 }}
        scroll={{ x: 1000 }}
      />
    </div>
  );
}

export default ReviewManagementTemplate;
